import Select from "../forms/inputs/Select";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

export default function RoleSelect({companyType, canChangeCompanyType = false, roles, ...props}) {
  const { t } = useTranslation();
  const [roleOptions, setRoleOptions] = useState([])
  const [value, setValue] = useState("")

  useEffect(() => {
    if (companyType && companyType != 'nil_class') {
      setRoleOptions(roles.filter(role => role.startsWith(companyType)))
    } else {
      setRoleOptions(roles)
    }
  }, [companyType, roles])


  const labelize = (option) => (canChangeCompanyType ? option : option.replace(`${companyType}_`, ''))

  useEffect(() => {
    setValue(props.isMulti ? props.value : props.value[0])
  }, [props.value])

  const onChange = (val) => {
    props.onChange(props.isMulti ? val : [val])
  }

  return <Select isClearable={false} {...props} value={value} onChange={onChange}>
    {roleOptions.map(option => <Option value={option} key={option}>{t(`user.${labelize(option)}`).replace(/user\./, '')}</Option>)}
  </Select>
}
